import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BaseComponent } from './views/layout/base/base.component';
import { AuthGuard } from './core/guard/auth.guard';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/pages/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./views/pages/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },
      {
        path: 'organization',
        loadChildren: () =>
          import('./views/pages/organization/organization.module').then(
            (m) => m.OrganizationModule
          ),
      },
      {
        path: 'division',
        loadChildren: () =>
          import('./views/pages/division/division.module').then(
            (m) => m.DivisionModule
          ),
      },
      {
        path: 'subdivision',
        loadChildren: () =>
          import('./views/pages/subdivision/subdivision.module').then(
            (m) => m.SubdivisionModule
          ),
      },
      {
        path: 'department',
        loadChildren: () =>
          import('./views/pages/department/department.module').then(
            (m) => m.DepartmentModule
          ),
      },
      {
        path: 'rank',
        loadChildren: () =>
          import('./views/pages/rank/rank.module').then((m) => m.RankModule),
      },
      {
        path: 'position',
        loadChildren: () =>
          import('./views/pages/position/position.module').then(
            (m) => m.PositionModule
          ),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./views/pages/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'application',
        loadChildren: () =>
          import('./views/pages/application/application.module').then(
            (m) => m.ApplicationModule
          ),
      },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  {
    path: 'error',
    component: ErrorPageComponent,
    data: {
      type: 404,
      title: 'Page Not Found',
      desc: "Oopps!! The page you were looking for doesn't exist.",
    },
  },
  {
    path: 'error/:type',
    component: ErrorPageComponent,
  },
  { path: '**', redirectTo: 'error', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
